import { render, staticRenderFns } from "./JobTitleBlock.vue?vue&type=template&id=398915bb&scoped=true"
import script from "./JobTitleBlock.vue?vue&type=script&lang=ts"
export * from "./JobTitleBlock.vue?vue&type=script&lang=ts"
import style0 from "./JobTitleBlock.vue?vue&type=style&index=0&id=398915bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398915bb",
  null
  
)

export default component.exports